import { render, staticRenderFns } from "./AssignmentSettingToIpRadio.vue?vue&type=template&id=3aa34275&scoped=true"
import script from "./AssignmentSettingToIpRadio.vue?vue&type=script&lang=js"
export * from "./AssignmentSettingToIpRadio.vue?vue&type=script&lang=js"
import style0 from "./AssignmentSettingToIpRadio.vue?vue&type=style&index=0&id=3aa34275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa34275",
  null
  
)

export default component.exports